module.exports = __webpack_public_path__ + "img/取消检品.3c57b423.png";